import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {NgIf} from "@angular/common";
import {IIncentive, IIncentiveItem} from "../../../interfaces/incentive";

@Component({
  selector: 'lib-poll-incentive',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './poll-incentive.component.html',
  styleUrls: ['./poll-incentive.component.css'],
})
export class PollIncentiveComponent implements OnInit {
  btnDescription = '';
  @Input() type: 'initial' | 'winner' = 'initial';
  @Input() incentiveFlat!: IIncentive;
  @Input() drawNumber: number = 0;
  @Output() action = new EventEmitter<'initial' | 'winner'>();

  incentive!: IIncentiveItem;

  constructor() {
  }

  btnOnClick(): void {
    this.action.emit(this.type);
  }

  ngOnInit(): void {
    if (this.type === 'initial') {
      this.btnDescription = 'Começar';
    } else {
      this.btnDescription = 'Sair';
    }

    this.incentive = {
      title: this.type === 'initial' ? this.incentiveFlat?.noticePageTitle : this.incentiveFlat?.winnerPageTitle,
      description: this.type === 'initial' ? this.incentiveFlat?.noticePageDescription : this.incentiveFlat?.winnerPageDescription,
      img: this.type === 'initial' ? this.incentiveFlat?.noticePageImg : this.incentiveFlat?.winnerPageImg,
    };
  }
}
